import { render, staticRenderFns } from "./EditEffectiveShift.vue?vue&type=template&id=819625ae"
import script from "./EditEffectiveShift.vue?vue&type=script&lang=js"
export * from "./EditEffectiveShift.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports